import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

@Component({
  selector: 'un-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.less'],
  standalone: false,
})
export class StepComponent implements OnChanges {
  @Input() unTitle?: string;
  @Input() description?: string;
  @Input() key?: string;
  @Input() valid?: boolean = true;
  @Input() form?: FormGroup | FormArray | AbstractControl | null;
  @Input() visited = false;
  @Output() validChange = new EventEmitter<boolean>();
  @Output() stepChanged = new EventEmitter<{ key?: string; index: number }>();
  private _selected: boolean;
  public visitCount = 0;

  @Input() set selected(selected: boolean) {
    if (selected) {
      this.visitCount++;
      this.visited = true;
    }
    this._selected = selected;
  }

  get selected() {
    return this._selected;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['valid']) this.validChange.emit(this.valid);
  }
}
